import type { StoreApi } from 'zustand';
import useFlowNextStore from '$/store/useTeamFlowStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import { getRegisteredTeamFlowContext, subscribeTeamFlowContextChange } from './teamFlowContextRegistry';
import { getLoadedTeamFlowIdentity, subscribeLoadedTeamFlowIdentity } from './teamFlowLoadedIdentity';

const flowStore = useFlowNextStore as unknown as StoreApi<{ projectId: string; roomId: string; }>;

/** 只跟踪创建来源所属的账号和画布，不因选中节点或鼠标移动废弃操作。 */
function getIdentity(): string {
  const { projectId, roomId } = flowStore.getState();
  const {
    userInfo, clientOId, clientId, isOverseaServer,
  } = useOfficialStore.getState();
  return JSON.stringify([projectId, roomId, userInfo?.uid, clientOId ?? 0, clientId, isOverseaServer]);
}

let identity = getIdentity();
let epoch = 0;
let registered = getRegisteredTeamFlowContext();

/** 单调版本可识别 A→B→A，防止旧创建请求在切回同一账号或房间后恢复导航。 */
function onIdentityChanged(): void {
  const next = getIdentity();
  if (next !== identity) { identity = next; epoch += 1; }
}

flowStore.subscribe(onIdentityChanged);
useOfficialStore.subscribe(onIdentityChanged);
subscribeTeamFlowContextChange((next) => {
  if (next !== registered) { registered = next; epoch += 1; }
});
subscribeLoadedTeamFlowIdentity(() => { epoch += 1; });

/** 在点击时同步捕获创建来源，异步加载或请求迟到也不能把导航归属移到新画布。 */
export function captureMyIpCanvasContext(): () => boolean {
  const ctx = getRegisteredTeamFlowContext();
  const loaded = getLoadedTeamFlowIdentity(ctx);
  const version = epoch;
  return () => {
    const { projectId, roomId } = flowStore.getState();
    const {
      userInfo, clientOId, clientId, isOverseaServer,
    } = useOfficialStore.getState();
    const scopeKey = JSON.stringify([userInfo?.uid, clientOId ?? 0, clientId, isOverseaServer]);
    return Boolean(ctx && loaded && loaded.projectId && loaded.roomId
      && getRegisteredTeamFlowContext() === ctx && getLoadedTeamFlowIdentity(ctx) === loaded && version === epoch
      && loaded.projectId === projectId && loaded.roomId === roomId && loaded.scopeKey === scopeKey);
  };
}
